import React from 'react'
import { X } from 'lucide-react'

type ClearButtonProps = {
  name: string
  onClick: () => void
  className?: string
  hidden?: boolean
  'data-testid'?: string
}

export const ClearButton: React.FC<ClearButtonProps> = ({
  name,
  onClick,
  className = '',
  hidden = false,
  'data-testid': dataTestId,
}) => {
  if (hidden) return null

  return (
    <button
      type="button"
      className={`input__clear-button ${className}`}
      onClick={onClick}
      aria-label={`Clear ${name} field`}
      data-testid={dataTestId || `clear-${name}`}
    >
      <X size={16} />
    </button>
  )
}
